import { AgGridReact } from "ag-grid-react";
import { useRef } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import useUiuxStore from "src/store/useUiuxStore";
import { useMouseContent } from "src/utils/mouse/mouseContent";
import { Content_KSK1120_R01 } from "./Content_KSK1120_R01";
import { DetailTable_KSK1120_R01 } from "./DetailTable_KSK1120_R01";
import {
	KSK1120_R01DetailDto,
	KSK1120_R01HeaderDto,
} from "./Dto_KSK1120_R01";
import { Info_KSK1120_R01 } from "./Info_KSK1120_R01";
import { SearchSection_KSK1120_R01 } from "./SearchSection_KSK1120_R01";
import { Table_KSK1120_R01 } from "./Table_KSK1120_R01";

const TABLE_INFO_RESIZER = {
	code: "KSK1120_R01",
	type: "height" as const,
	storageKey: "KSK1120_R01-table-info-split-height",
	min: 25,
	max: 80,
	default: 55,
};

const INFO_DETAIL_RESIZER = {
	code: "KSK1120_R01",
	type: "height" as const,
	storageKey: "KSK1120_R01-info-detail-split-height",
	min: 15,
	max: 70,
	default: 35,
};

export const Container_KSK1120_R01 = () => {
	useFetchActionbarAuth("KSK1120_R01");
	const { setMessage } = useUiuxStore();
	const gridRef = useRef<AgGridReact<KSK1120_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<KSK1120_R01DetailDto>>(null);
	const containerRef = useRef<HTMLDivElement>(null);
	const bottomPanelRef = useRef<HTMLDivElement>(null);
	const infoPanelRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);
	const isInfoDetailResizing = useRef(false);

	const {
		splitValue,
		handleMouseDown,
	} = useMouseContent({
		resizer: TABLE_INFO_RESIZER,
		isResizing,
		containerRef,
	});

	const {
		splitValue: infoDetailSplitValue,
		handleMouseDown: handleInfoDetailMouseDown,
	} = useMouseContent({
		resizer: INFO_DETAIL_RESIZER,
		isResizing: isInfoDetailResizing,
		containerRef: bottomPanelRef,
		infoRef: infoPanelRef,
	});

	const {
		fetchData,
		fetchOne,
		handleDeleteClick,
		handleSaveClick,
		initContainerData,
	} = Content_KSK1120_R01({ gridRef, detailGridRef, setMessage });

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onInitClick={initContainerData}
			/>
			<SearchSection_KSK1120_R01 />
			<div ref={containerRef} className="flex flex-1 min-h-0 flex-col p-[12px] gap-[4px]">
				<div
					className="w-full min-h-0 flex flex-col"
					style={{ height: `${splitValue}%` }}
				>
					<Table_KSK1120_R01
						gridRef={gridRef}
						fetchOne={fetchOne}
					/>
				</div>
				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300 shrink-0"
					onMouseDown={(event) => handleMouseDown("UD", event.nativeEvent)}
					onDragStart={(event) => event.preventDefault()}
				/>
				<div
					ref={bottomPanelRef}
					className="w-full min-h-0 flex flex-col gap-[4px]"
					style={{ height: `${100 - splitValue}%` }}
				>
					<div
						ref={infoPanelRef}
						className="w-full min-h-0 overflow-hidden"
						style={{
							height: `${infoDetailSplitValue}%`,
							maxHeight: `${infoDetailSplitValue}%`,
						}}
					>
						<Info_KSK1120_R01 />
					</div>
					<div
						className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300 shrink-0"
						onMouseDown={(event) => handleInfoDetailMouseDown("UD", event.nativeEvent)}
					/>
					<div
						className="w-full min-h-0 flex flex-col"
						style={{ height: `${100 - infoDetailSplitValue}%` }}
					>
						<DetailTable_KSK1120_R01 detailGridRef={detailGridRef} />
					</div>
				</div>
			</div>
		</div>
	);
};
